"use strict";

module.exports = JSON.parse("{\"generic\":\"https://323801-aemseismicassetsync-stage.adobeioruntime.net/api/v1/dx-excshell-1/generic\",\"dx-excshell-1/generic\":\"https://323801-aemseismicassetsync-stage.adobeioruntime.net/api/v1/dx-excshell-1/generic\"}");